export const priceFormatter = (amount?: number) => {
  if (!amount && amount !== 0) return ''

  const priceFormatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY'
  })

  return priceFormatter.format(amount).replace(/￥/, '¥')
}
